export const formField = {
  legalFirstName: "LegalFirstName",
  middleName: "MiddleName",
  legalLastName: "LegalLastName",
  salutation: "Salutation",
  suffix: "Suffix",
  gender: "Gender",
  maritalStatus: "MaritalStatus",
  primaryLanguage: "PrimaryLanguage",
  secondaryLanguage: "SecondaryLanguage",
  dob: "DOB",
  countryOfBirth: "CountryOfBirth",
  nationality: "Nationality",
  ssN_US: "SSN_US",
  jobReqCountryCode: "JobReqCountryCode",
  homeAddress1: "HomeAddress1",
  homeAddress2: "HomeAddress2",
  apartment: "Apartment",
  city: "City",
  stateID: "StateID",
  stateName: "StateName",
  zipCode: "ZipCode",
  mobilePrimaryPhone: "MobilePrimaryPhone",
  secondaryPhone: "SecondaryPhone",
  emergencyContactRelationID1: "EmergencyContactRelationID1",
  emergencyContactRelationName1: "EmergencyContactRelationName1",
  emergencyContactName1: "EmergencyContactName1",
  emergencyContactPhone1: "EmergencyContactPhone1",
  emergencyContactAltPhone1: "EmergencyContactAltPhone1",
  emergencyContactEmail1: "EmergencyContactEmail1",
  emergencyContactRelationID2: "EmergencyContactRelationID2",
  emergencyContactRelationName2: "EmergencyContactRelationName2",
  emergencyContactName2: "EmergencyContactName2",
  emergencyContactPhone2: "EmergencyContactPhone2",
  emergencyContactAltPhone2: "EmergencyContactAltPhone2",
  emergencyContactEmail2: "EmergencyContactEmail2",
  ethnicity: "Ethnicity",
  race: "Race",
  disability: "Disability",
  veteran: "Veteran",
  offerAcceptedInd: "OfferAcceptedInd",

  siN_CA: "SIN_CA",
  countryCode: "CountryCode",
  countryName: "CountryName",
  streetAndHouseNumber: "StreetAndHouseNumber",

  hkiD_HK: "HKID_HK",
  extraAddressLine: "ExtraAddressLine",
  street: "Street",
  district: "District",
  areaCode: "AreaCode",

  permanent_Account_Number_IN: "Permanent_Account_Number_IN",
  aadhaR_IN: "AADHAR_IN",
  voterID_IN: "VoterID_IN",
  driversLicenseNo_IN: "DriversLicenseNo_IN",
  houseNumber: "HouseNumber",
  isPrimaryAddressSameAsMailing: "IsPrimaryAddressSameAsMailing",
  mailingHouseNumber: "MailingHouseNumber",
  mailingStreet: "MailingStreet",
  mailingStreetAndHouseNumber: "MailingStreetAndHouseNumber",
  mailingExtraAddressLine: "MailingExtraAddressLine",
  mailingCity: "MailingCity",
  mailingDistrict: "MailingDistrict",
  mailingStateID: "MailingStateID",
  mailingStateName: "MailingStateName",
  mailingZipCode: "MailingZipCode",
  fatherHusbandLegalGuardianName: "FatherHusbandLegalGuardianName",

  secondLastName: "SecondLastName",
  clave_Unica_MX: "Clave_Unica_MX",
  imsS_MX: "IMSS_MX",
  rfC_MX: "RFC_MX",
  region: "Region",
  municipality: "Municipality",

  cedula_Number_PA: "Cedula_Number_PA",
  seguro_Social_PA: "Seguro_Social_PA",
  passportNo_PA: "PassportNo_PA",
  buildingNeighborhoodName: "BuildingNeighborhoodName",

  placeOfBirth: "PlaceOfBirth",
  paG_IBIG_Number_PH: "PAG_IBIG_Number_PH",
  philhealtH_Number_PH: "PHILHEALTH_Number_PH",
  tiN_PH: "TIN_PH",
  ssS_Number_PH: "SSS_Number_PH",
  streetVillageSubDivisionBarangay: "StreetVillageSubDivisionBarangay",
  cityMunicipality: "CityMunicipality",

  peseL_PL: "PESEL_PL",
  community: "Community",

  national_Identification_Card_TT: "National_Identification_Card_TT",
  passportNo_TT: "PassportNo_TT",
  national_Insurance_Number_TT: "National_Insurance_Number_TT",
  biR_TT: "BIR_TT",
  mailingCountryID: "MailingCountryID",
  mailingCountryCode: "MailingCountryCode",
  mailingCountryName: "MailingCountryName",
  cedula_De_Ciudadania_CO: "Cedula_De_Ciudadania_CO",
  streetAvenueNumber: "StreetAvenueNumber",

  mothersMaidenFirstName: "MothersMaidenFirstName",
  mothersMaidenMiddleName: "MothersMaidenMiddleName",
  mothersMaidenLastName: "MothersMaidenLastName",

  religion: "Religion",
  militaryStatus: "MilitaryStatus",
  graduate: "Graduate",
  university: "University",
  faculty: "Faculty",
  graduationYear: "GraduationYear",
  national_Identification_Card_EG: "National_Identification_Card_EG",
  tax_File_Number_AU: "Tax_File_Number_AU"
};
